module.exports = __webpack_public_path__ + "img/activity_login.b56d9433.png";